import { useMediaQuery } from "@chakra-ui/react";
import { PricingOptionsProps } from "@ui/application/pricing/src";
import { DesktopPricingTable } from "./desktop-pricing-table";
import { MobilePricingTable } from "./mobile-pricing-table";

interface PricingTablePlans {
  planName: string;
  tableSubtitle: string;
  mobileButtonText: string;
  mobileButtonLink: string;
}

interface PricingTableRowText {
  rowName: string;
  textRowBasic: string;
  textRowPro: string;
  textRowEnterprise: string;
}

interface PricingTableRowBoolean {
  rowName: string;
  booleanRowBasic: boolean;
  booleanRowPro: boolean;
  booleanRowEnterprise: boolean;
}
export interface PricingTableProps {
  pricingOptions: PricingOptionsProps[];
  pricingPlans: PricingTablePlans[];
  pricingTableRows: (PricingTableRowText | PricingTableRowBoolean)[];
}

export const PricingTable = ({
  pricingOptions,
  pricingPlans,
  pricingTableRows,
}: PricingTableProps) => {
  const [isLargerThan1000] = useMediaQuery("(min-width: 1000px)");

  return (
    <>
      {isLargerThan1000 ? (
        <DesktopPricingTable
          pricingOptions={pricingOptions}
          pricingPlans={pricingPlans}
          pricingTableRows={pricingTableRows}
        />
      ) : (
        <MobilePricingTable
          pricingOptions={pricingOptions}
          pricingPlans={pricingPlans}
          pricingTableRows={pricingTableRows}
        />
      )}
    </>
  );
};
